import { PaginatedResponse } from '@dynamika-shared/types/general';

export function mockPaginate<C>(
  items: C[],
  args = { page: 1, size: 10 }
): PaginatedResponse<C> {
  const pages = Math.ceil(items.length / args.size);
  const content = items.slice(
    args.page * args.size,
    (args.page + 1) * args.size
  );
  return {
    totalPages: pages,
    totalElements: items.length,
    last: pages === args.page,
    size: args.size,
    number: args.page,
    numberOfElements: content.length,
    pageable: {
      offset: args.page * args.size,
      paged: true,
      pageNumber: args.page,
      pageSize: args.size,
      sort: {
        empty: false,
        sorted: false,
        unsorted: true,
      },
      unpaged: false,
    },
    sort: {
      sorted: false,
      unsorted: true,
      empty: items.length === 0,
    },
    first: args.page === 1,
    empty: items.length === 0,
    content,
  };
}
